import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import React from 'react'
import styled from 'styled-components'

const query = graphql`
  query {
    logo:file(relativePath: { eq: "header.png" }) {
      childImageSharp {
        fluid(maxWidth: 300) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
  }
`

const Logo = styled(Img)`
  margin: auto;
  width: 100%;
  max-width: 300px;
`

const Header = props => (
  <StaticQuery
    query={query}
    render={data => (
      <div className={props.className}>
        <Logo fluid={data.logo.childImageSharp.fluid}  />
      </div>
    )}
  />
)

const StyledHeader = styled(Header)`
  background: white;
  box-shadow: ${props => props.theme.shadow};
  padding: 0.75rem 1.25rem;
  text-align: center;
`

export default StyledHeader
